import { defineStore } from "pinia";
import { store } from "../index";

export interface TabbarState {
  pendingApproval: Number;
}

export const useTabbarStore = defineStore("tabbar", {
  state: (): TabbarState => ({
    pendingApproval: 0,
  }),
  getters: {
    getPendingApproval(): Number {
      return this.pendingApproval;
    },
  },
  actions: {
    setPendingApproval(number: Number) {
      this.pendingApproval = number;
    },
  },
});

export const useTabbarStoreWithOut = () => {
  return useTabbarStore(store);
};
